var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import "../../Utilities.js";
import { Dialog as Dialog$1, DialogFooter } from "@fluentui/react/lib/Dialog";
import { css } from "@fluentui/utilities";
const defaultClassName = "ane-Dialog";
const contentClassName = "ane-Dialog-content";
const footerClassName = "ane-Dialog-footer";
class Dialog extends React.Component {
  render() {
    var _b;
    const _a = this.props, { children, className, onRenderFooter } = _a, rest = __objRest(_a, ["children", "className", "onRenderFooter"]);
    const restModalProps = __objRest((_b = this.props.modalProps) != null ? _b : {}, []);
    return /* @__PURE__ */ jsxs(
      Dialog$1,
      __spreadProps(__spreadValues({}, rest), {
        modalProps: __spreadValues({
          className: css(defaultClassName, className)
        }, restModalProps),
        children: [
          /* @__PURE__ */ jsx("div", { className: css(contentClassName, className), children }),
          !!onRenderFooter && /* @__PURE__ */ jsx(DialogFooter, { children: /* @__PURE__ */ jsx("div", { className: css(footerClassName, className), children: onRenderFooter(this.props) }) })
        ]
      })
    );
  }
}
export {
  Dialog,
  Dialog as default
};
//# sourceMappingURL=Dialog.js.map
